import React from "react";
import PropTypes from "prop-types";
import { SITE_STATUS } from "../contextapi/SettingsContext";
import "./SiteStatusPage.css";

const COPY = {
  [SITE_STATUS.MAINTENANCE]: {
    eyebrow: "Maintenance",
    title: "We'll be right back",
    description:
      "Mockee is undergoing scheduled maintenance. The site is temporarily unavailable while we improve things behind the scenes.",
    hint: "Please check back shortly. Thank you for your patience.",
  },
  [SITE_STATUS.DOWN]: {
    eyebrow: "Service unavailable",
    title: "Mockee is temporarily unavailable",
    description:
      "We're experiencing an unexpected outage and have taken the platform offline to protect your data and restore service safely.",
    hint: "Our team is working on it. Please try again later.",
  },
};

/**
 * Full-viewport branded gate for MAINTENANCE / DOWN.
 * Renders instead of the app — no nav/footer.
 */
const SiteStatusPage = ({ status }) => {
  const content = COPY[status] || COPY[SITE_STATUS.DOWN];

  return (
    <div className="site-status-page" role="alert" aria-live="polite">
      <div className="site-status-page__atmosphere" aria-hidden="true" />
      <div className="site-status-page__panel">
        <img
          src="/assets/images/justLogo.svg"
          alt="Mockee"
          className="site-status-page__logo"
        />
        <p className="site-status-page__eyebrow">{content.eyebrow}</p>
        <h1 className="site-status-page__title">{content.title}</h1>
        <p className="site-status-page__description">{content.description}</p>
        <p className="site-status-page__hint">{content.hint}</p>
        <a
          className="site-status-page__contact"
          href="mailto:contact@mockee.io"
        >
          Contact support
        </a>
      </div>
    </div>
  );
};

SiteStatusPage.propTypes = {
  status: PropTypes.oneOf([SITE_STATUS.MAINTENANCE, SITE_STATUS.DOWN])
    .isRequired,
};

export default SiteStatusPage;
